// extracted by mini-css-extract-plugin
export default {"tooltip":"YzKcT","link":"OGO9L","active":"nJNsc","flag":"h65qu","flagHover":"YuJmB","wrapper":"X9y35"};